import amine from './amine.png';
import carp from './carp.png';
import cashm from './cashm.png';
import cashmail from './cashmail.png';
import check from './check.png';
import dboe from './dboe.png';
import ibnou from './ibnou.png';
import niclas from './niclas.png';
import saket from './saket.png';
import solan from './solan.png';
import vvian from './vvian.png';


const images = {
    amine: amine,
    carp: carp,
    cashm: cashm,
    cashmail: cashmail,
    check: check,
    ibnou: ibnou,
    dboe: dboe,
    niclas: niclas,
    saket: saket,
    solan: solan,
    vvian: vvian,

}

export default images;